import { render, staticRenderFns } from "./comparison-table-package.vue?vue&type=template&id=5633636e&scoped=true&"
import script from "./comparison-table-package.vue?vue&type=script&lang=ts&"
export * from "./comparison-table-package.vue?vue&type=script&lang=ts&"
import style0 from "./comparison-table-package.vue?vue&type=style&index=0&id=5633636e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5633636e",
  null
  
)

export default component.exports